import { createAction, props } from '@ngrx/store';
import { StoreTypes } from "mbs-ui-shared@store/storeTypes.enum";
import { SnmpAlertDeviceTypes, SnmpAlertTypes, SnmpDeviceCustomProperty } from './model';

export const setLoading = createAction(`[${StoreTypes.SnmpAlerts}] Set Alerting Loading`, props<{ loading: boolean }>());
export const loadAlertingInfo = createAction(`[${StoreTypes.SnmpAlerts}] Load All Alerting Info`);

export const loadSnmpDeviceTypes = createAction(`[${StoreTypes.SnmpAlerts}] Load Snmp Device Types`);
export const loadSnmpAlertTypes = createAction(`[${StoreTypes.SnmpAlerts}] Load Snmp Alert Types`);
export const loadSnmpAlertCustomisation = createAction(`[${StoreTypes.SnmpAlerts}] Load Snmp Alert Customisation`);

export const setSnmpDeviceTypes = createAction(
  `[${StoreTypes.SnmpAlerts}] Set Snmp Device Types`,
  props<{ deviceTypes: SnmpAlertDeviceTypes[] }>()
);
export const setSnmpAlertTypes = createAction(`[${StoreTypes.SnmpAlerts}] Set Snmp Alert Types`, props<{ alertTypes: SnmpAlertTypes[] }>());
export const setSnmpAlertCustomisation = createAction(
  `[${StoreTypes.SnmpAlerts}] Set Snmp Alert Customisation`,
  props<{ data: string[] }>()
);

export const fullLoadComplete = createAction(
  `[${StoreTypes.SnmpAlerts}] All Snmp Alerting Info Loaded`,
  props<{ alertTypes: SnmpAlertTypes[]; deviceTypes: SnmpAlertDeviceTypes[] }>()
);

export const addCustomProperties = createAction(
  `${StoreTypes.SnmpAlerts} Save Custom Properties for Device Type`,
  props<{ deviceType: number; property: SnmpDeviceCustomProperty }>()
);

export const loadDevicePropertiesCustom = createAction(
  `[${StoreTypes.SnmpAlerts}] Load Custom Properties by Device Type`,
  props<{ deviceType: number }>()
);

export const setCustomProperties = createAction(
  `[${StoreTypes.SnmpAlerts}] Set Device Type Custom Properties`,
  props<{ snmpDeviceCustomProperty: any }>()
);

export const updateCustomProperties = createAction(
  `[${StoreTypes.SnmpAlerts}] Update Device Type Custom Properties`,
  props<{ deviceType: number; snmpDeviceTypeGuid: string; property: SnmpDeviceCustomProperty }>()
);

export const removeCustomProperties = createAction(
  `[${StoreTypes.SnmpAlerts}] Remove Device Type Custom Properties`,
  props<{ deviceType: number; snmpDeviceTypeGuid: string }>()
);

export const resetCustomProperties = createAction(`[${StoreTypes.SnmpAlerts}] Reset Device Type Custom Properties`);
